export default prefix => ([
    {
        redirect: true,
        exact: true,
        from: prefix,
        to: `/admin/sifarish`,
    },
])
